/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DealerService {

  citys = [
    // {icon:'',label:'City'},
    {icon:'https://s3-afterbricks.s3.amazonaws.com/media/icon_build/630ghaziabad.png',value:630,label:'Ghaziabad',id:'0'},
    {icon:'https://s3-afterbricks.s3.amazonaws.com/media/icon_build/207gurugram.png',value:207,label:'Gurugram',id:'1'},
    { icon: 'https://s3-afterbricks.s3.amazonaws.com/media/icon_build/652noida.png', value: 652, label: 'Noida', id: '2' },
    { icon: 'https://s3-afterbricks.s3.amazonaws.com/media/icon_build/178delhi.png', value: 178, label: 'New Delhi', id: '3' },
  ]
  data:any;
}
